import {
  IVerifyEmailRequest,
  IVerifySMSRequest,
  IResendOTPRequest,
  IVerifyOTPRequest,
  IResetPasswordRequest,
} from 'src/shared/interface/forgot-password';
import request from '../request';

export const verifyEmailForReset = async (data: IVerifyEmailRequest) => {
  const url = `${process.env.REACT_APP_IAM_URL}/api/v1/user/update-password/verify-info`;
  const payload = {
    appCode: data.appCode,
    email: data.email,
    username: data.username,
  };
  const res = await request('post', url, payload);
  return res;
};

export const verifySMSForReset = async (data: IVerifySMSRequest) => {
  const url = `${process.env.REACT_APP_IAM_URL}/api/v1/user/update-password/verify-info`;
  const payload = {
    appCode: data.appCode,
    phoneNumber: data.phoneNumber,
    username: data.phoneNumber,
  };
  const res = await request('post', url, payload);
  return res;
};

export const resendOTP = async (data: IResendOTPRequest) => {
  const url = `${process.env.REACT_APP_IAM_URL}/api/v1/otp/update-password/send-otp`;
  const payload = {
    username: data.username,
    destAddress: data.destAddress,
    appCode: data.appCode,
    type: data.type,
    language: data.language,
  };
  const res = await request('post', url, payload);
  return res;
};

export const verifyOTP = async (data: IVerifyOTPRequest) => {
  const url = `${process.env.REACT_APP_IAM_URL}/api/v1/otp/update-password/verify-otp`;
  const payload = {
    username: data.username,
    destAddress: data.destAddress,
    appCode: data.appCode,
    otp: data.otp,
    type: data.type,
  };
  const res = await request('post', url, payload);
  return res;
};

export const resetPassword = async (data: IResetPasswordRequest) => {
  const url = `${process.env.REACT_APP_IAM_URL}/api/v1/user/update-password`;
  const payload = {
    username: data.username,
    appCode: data.appCode,
    newPassword: data.newPassword,
    otpToken: data.otpToken,
  };
  const res = await request('post', url, payload);
  return res;
};
